module.exports = {
  MUSIC_ITEMS_PER_PAGE: 20,
  COVER_ITEMS_PER_PAGE: 16,
  SEARCH_PANEL_ITEMS: 10,
  DESC_CHAR_LIMIT: 150,
};
